import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=59736d64&scoped=true&"
import script from "./CustomerSettings.vue?vue&type=script&lang=ts&"
export * from "./CustomerSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=59736d64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59736d64",
  null
  
)

export default component.exports